import RepairRequestStatusBadge from '#/modules/crmMgmt/aftersales/repairRequest/components/RepairRequestStatusBadge';
import { formatDateOrDash } from '#/utils/date';

/** Block A：僅狀態 */
export const repairRequestSideMsgStatusBlock = {
  fields: [
    {
      key: 'status',
      label: '狀態',
      render: (row) => (
        <div className="side_msg-row">
          <h3>狀態</h3>
          <RepairRequestStatusBadge status={row?.status} size="default" />
        </div>
      ),
    },
  ],
};

/** Block C+：其餘欄位 */
export const repairRequestSideMsgDetailBlock = {
  fields: [
    { label: '報修單號', value: 'repairRequestNo' },
    {
      label: '報修日',
      value: (row) => formatDateOrDash(row?.repairRequestDate),
    },
    { label: '客戶名稱', value: 'customerName' },
    { label: '聯絡人', value: 'contactName' },
    { label: '電話', value: 'phone' },
    { label: '傳真', value: 'fax' },
    { label: '統編', value: 'taxId' },
    { label: '地址', value: 'address' },
    {
      label: '收件日',
      value: (row) => formatDateOrDash(row?.receivedDate),
    },
    {
      label: '項目數',
      value: (row) => row?.itemCount ?? row?.lines?.length ?? 0,
    },
    { label: '備註', value: 'remark' },
  ],
};

export const repairRequestSideMsgBlocks = [
  repairRequestSideMsgStatusBlock,
  repairRequestSideMsgDetailBlock,
];
